var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-aside',{staticClass:"left",attrs:{"width":"400px"}},[_c('Logo',{attrs:{"height":60}}),_c('Scenes'),_c('Actions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }